export const  DragTypes  = {
    CHECKLISTITEM  : 'checklistitem',
    CHECKLIST : 'checklist',
    WORKFLOW : 'workflow',
    ACTIVITY : 'activity'
};
// export const ItemTypes = {
//     KNIGHT: 'knight',
//   }